export enum WorkPanelBarItemType {
  Button = 1,
  Icon = 2,
}

export interface WorkPanelBarItem {
  name: string;
  type?: WorkPanelBarItemType;
  tooltip: () => string;
  onClick: (param?) => void;
  icon: () => string;
  isVisible: () => boolean;
  tabIndex?: number;
  selected: (tabIndex?) => boolean;
  spinning?: () => boolean;
  cssClass?: () => string;
  isDisabled: (tabIndex?) => boolean;
}
